export default "__VITE_ASSET__Ihp$bQat__"